import React from 'react';
import { useTranslation } from 'react-i18next';
import { latestAdultBirthDate } from '../utils/agePolicy';

export default function DateOfBirthField({ value, onChange, error, prefix = 'account', className = '' }) {
  const { t } = useTranslation();
  return <div className={className}>
    <label htmlFor={`${prefix}-dateOfBirth`} className="block text-sm font-medium text-gray-700">{t('agePolicy.dateOfBirth')}</label>
    <input id={`${prefix}-dateOfBirth`} name="dateOfBirth" type="date" required min="0001-01-01"
      max={latestAdultBirthDate()} value={value || ''} onChange={onChange}
      aria-describedby={error ? `${prefix}-age-error` : undefined} aria-invalid={Boolean(error)}
      data-testid={`${prefix}-date-of-birth-input`} className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-3 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500" />
    {error && <p id={`${prefix}-age-error`} role="alert" className="mt-1 text-sm text-red-600">{error}</p>}
  </div>;
}
